/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {FormControl, FormGroup} from "@angular/forms";
import { customRequiredValidation } from '@irian-ro/shared-components-module';

export class LegalEntityTermsAndConditionsDto extends JSONable {

  ownerLegalEntityUuid: string | undefined = undefined;
  forLegalEntityUuid: string | undefined = undefined;
  majorVersion: number | undefined = undefined;
  minorVersion: number | undefined = undefined;
  validFrom: string | undefined = undefined;
  validTo: string | undefined = undefined;
  template: string | undefined = undefined;
  documentType: string | undefined = undefined;
  documentLanguage: string | undefined = undefined;

  static createForm(): FormGroup {
    return new FormGroup({
        uuid: new FormControl(null),
        forLegalEntityUuid: new FormControl(null),
        validFrom: new FormControl(new Date(), customRequiredValidation('ValidFrom')),
        validTo: new FormControl(null),
        template: new FormControl(null, customRequiredValidation('Template')),
        documentType: new FormControl(null, customRequiredValidation('DocumentType')),
        documentLanguage: new FormControl(null, customRequiredValidation('DocumentLanguage')),
      }
    );
  }
}
